import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutPageResolverService implements Resolve<string> {
  resolve(route: ActivatedRouteSnapshot): Observable<string> {
    const pageName = route.data['headerName'];
    return of(pageName || 'Default Page');
  }
}
